import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import EmptyInsuranceDetails from 'src/components/BuyPolicy/common/EmptyInsuranceDetails'
import { MOCK_QUICK_QUOTES } from 'src/utils/constants/BuyPolicyLife'
import LifeQuickQuoteTile from 'src/components/BuyPolicy/insuranceScreens/life/common/LifeQuickQuoteTile'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useHistory } from 'react-router-dom'

const LifeQuickQuotes = () => {
  const classes = useStyles()
  const history = useHistory()

  const [quotesList, setQuotesList] = useState([])

  useEffect(() => {
    setQuotesList(MOCK_QUICK_QUOTES)
  }, [])

  const handleBack = () => {
    history.push('/individual/dashboard/buyPolicy/life/')
  }

  return (
    <div className={classes.root}>
      {quotesList?.length ? (
        <div>
          <div>
            <div className={classes.heading}>Please find the quotes below</div>
            <div
              onClick={handleBack}
              className={classes.goBackButtonContainer}
              id='backButton'
            >
              <img src={arrow} alt='arrow' />
              <span className={classes.gotoBackButton}>Go back</span>
            </div>
          </div>
          <div className={classes.quotesContainer}>
            {quotesList?.map((quotesListItem) => {
              return (
                <div key={`lifeQuickQuotes-${quotesListItem?.enquiryId}`}>
                  <LifeQuickQuoteTile quoteDetails={quotesListItem} />
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        <EmptyInsuranceDetails />
      )}
    </div>
  )
}

export default LifeQuickQuotes

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  quotesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  goBackButtonContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
})
